export function buildSearchParams(
  searchParams: URLSearchParams,
  updates: Record<string, string>,
) {
  const next = new URLSearchParams(searchParams)

  Object.entries(updates).forEach(([key, value]) => {
    const normalized = value.trim()
    if (normalized) next.set(key, normalized)
    else next.delete(key)
  })

  next.delete('page')

  return next
}
